import React, { useState } from 'react'
import { LANDING_PAGE } from '../../../../content/data/landingPage'

import * as styles from './styles.module.css'

const ScreenshotsScreen = () => {
    const [hoveredScreen, setHoveredScreen] = useState(null)

    const pageData = LANDING_PAGE.screenshots

    var screenRefs = {}
    for (let screen of pageData) {
        screenRefs[screen.id] = {
            img: React.createRef(),
        }
    }

    const handleMouseEnter = (screenId) => {
        const screenData = pageData.find(({ id }) => id === screenId)

        const elem = screenRefs[screenId].img.current
        elem.style.transform = 'scale(1.1)'

        setHoveredScreen(screenData)
    }

    const handleMouseLeave = (screenId) => {
        const elem = screenRefs[screenId].img.current
        elem.style.transform = 'scale(1)'

        setHoveredScreen(null)
    }

    return (
        <section id="screenshots" className={styles.container}>
            <div className={styles.gridWrapper}>
                {pageData.map((screen) => (
                    <div
                        key={screen.id}
                        className={styles.screenContainer}
                        role="button"
                        tabIndex='0'
                        onMouseEnter={() => handleMouseEnter(screen.id)}
                        onMouseLeave={() => handleMouseLeave(screen.id)}
                    >
                        <a href={screen.cta.url} target={screen.cta.target}>
                            <img
                                ref={screenRefs[screen.id].img}
                                className={styles.screen}
                                src={`/img/screenshots/${screen.imageName}.jpg`}
                                alt="Kubevious Screenshot"
                            />
                        </a>

                        {!(hoveredScreen && hoveredScreen.id === screen.id) && (
                            <div className={styles.screenInfo}>
                                <div className={styles.screenInfoInner}>
                                    <div className={styles.screenContent}>
                                        {screen.content}
                                    </div>

                                    <a
                                        className={styles.screenButton}
                                        href={screen.cta.url}
                                        target={screen.cta.target}
                                    >
                                        {screen.cta.title}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}

export default ScreenshotsScreen
